// See https://developers.google.com/maps/documentation/javascript/styling for examples of styling.
// See https://developers.google.com/maps/documentation/javascript/style-reference for element types reference

interface MapStyler {
  color?: string;
}

interface MapStyle {
  featureType: string;
  elementType: string;
  stylers: MapStyler[];
}

interface MapOptions {
  gestureHandling: string;
  disableDefaultUI: boolean;
  styles: MapStyle[];
}

const mapOptions: MapOptions = {
  gestureHandling: 'cooperative',
  disableDefaultUI: true,
  styles: [
    {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [{ color: '#E8ECEE' }]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#9EE6F4' }]
    }
  ]
};

export default mapOptions;
